import React from "react";
//import Burger from "../navbar/hamburger/Burger";

const Logo = () => {
  return (
    <>
      <div className="logo">
        <div className="logo1">
          <div className="logo2">Book</div>
          <div className="logo3">BUS</div>
        </div>
        {/* <Burger/> */}
      </div>
    </>
  );
};

export default Logo;
